var _defs, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWholesaleOrder5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4a00e8;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #e0ef4d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.57,79.15l-82.5-31.94c-1.71-.66-3.61-.66-5.32,0l-82.5,31.94c-2.84,1.1-4.71,3.83-4.71,6.87V251.3h16.69v-120.56H247.6v120.56h16.69V86.02c0-3.04-1.87-5.78-4.71-6.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 160.95,
    y: 87.11,
    width: 26.92,
    height: 11.86,
    rx: 5.93,
    ry: 5.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.23,
    y: 120.71,
    width: 146.37,
    height: 11.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 101.23,
    y: 132.57,
    width: 146.37,
    height: 11.86
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 112.75,
    y: 190.9,
    width: 80.4,
    height: 80.4,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.66,225.38l-9.57-6.82c-.68-.48-1.59-.48-2.27,0l-9.57,6.82c-1.3,.92-3.09,0-3.09-1.59v-32.89h27.6v32.89c0,1.59-1.8,2.52-3.09,1.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 122.82,
    y: 255.67,
    width: 37.16,
    height: 6.09,
    rx: 2.73,
    ry: 2.73
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 54.21,
    y: 110.5,
    width: 80.4,
    height: 80.4,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.12,144.98l-9.57-6.82c-.68-.48-1.59-.48-2.27,0l-9.57,6.82c-1.3,.92-3.09,0-3.09-1.59v-32.89h27.6v32.89c0,1.59-1.8,2.52-3.09,1.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 64.28,
    y: 175.27,
    width: 37.16,
    height: 6.09,
    rx: 2.73,
    ry: 2.73
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 32.35,
    y: 190.9,
    width: 80.4,
    height: 80.4,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.26,225.38l-9.57-6.82c-.68-.48-1.59-.48-2.27,0l-9.57,6.82c-1.3,.92-3.09,0-3.09-1.59v-32.89h27.6v32.89c0,1.59-1.8,2.52-3.09,1.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.42,
    y: 255.67,
    width: 37.16,
    height: 6.09,
    rx: 2.73,
    ry: 2.73
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleOrder5);
export default __webpack_public_path__ + "static/media/wholesale_order_5.2c9cd697b2f64c4f9851e5d686d8d25d.svg";
export { ForwardRef as ReactComponent };